import { Routes, Route, Navigate, useParams } from "react-router-dom";
import Navigation from "../../../components/Navigation/Navigation.js";
import TeamView from "./TeamView";

const View = () => {
    const { distanceParam } = useParams();
    const distance = distanceParam.replace("distance", "");

    return <TeamView distance={distance} targetType={"PRE"} />;
};

const Team = () => {
  const tabs = [
    { path: "distance145", label: "145M(Kungdo)" },
    { path: "distance90", label: "90M(TarscaShild)" },
    { path: "distance70", label: "70M(Puta)" },
    { path: "distance30", label: "30M(Zamby)" },
  ];

  return (
    <>
      <Navigation
        tabs={tabs}
        basePath="/match-results/team"
        variant="tab"
      />

      <Routes>
        <Route path="/" element={<Navigate to="distance145" replace />} />
        <Route path=":distanceParam" element={<View />} />
      </Routes>
    </>
  );
};
export default Team;
